const paths = {
  listOffice: '/office/list'
};

export default paths;
